import  { tryJsonParse } from './functions.js';

export default function MultipleChoiceModule(element) {

    let initialChoices = element.dataset.choices ? tryJsonParse(element.dataset.choices) : [];

    const choices = new Choices(element, {
        noChoicesText: window.TRANSLATIONS.NO_CHOICES_TEXT,
        itemSelectText: window.TRANSLATIONS.ITEM_SELECT_TEXT,
        noResultsText: window.TRANSLATIONS.NO_RESULTS_TEXT,
        removeItemButton: true,
        shouldSort: false,
        choices: initialChoices,
    });

    element.choicesInstance = choices;

    let nameWithoutBrackets = element.name.replace(/\[\]/g, '');

    element.insertAdjacentHTML('beforebegin', '<input type="hidden" name="' + nameWithoutBrackets + '">');

    let placeholder = element.getAttribute('data-placeholder') || '';

    let refreshPlaceholder = function() {
        let inputElm = choices.input.element;
        if (element.value) {
            inputElm.placeholder = '';
        } else {
            inputElm.placeholder = placeholder;
            inputElm.style.minWidth = inputElm.placeholder.length + 'ch';
        }
    };

    element.addEventListener('change', refreshPlaceholder);

    refreshPlaceholder();
    
    return this;

}